import {
  Avatar,
  Box,
  Card as MuiCard,
  CardContent as MuiCardContent,
  Typography,
  type TypographyProps,
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const Card = styled(MuiCard)(() => ({
  position: "relative",
  borderRadius: 12,
  border: "1px solid #E5E7EB",
  boxShadow: "none",
  overflow: "hidden",
}));

export const Media = styled(Box)(() => ({
  aspectRatio: "16 / 9",
  overflow: "hidden",

  img: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
}));

export const CardContent = styled(MuiCardContent)(() => ({
  padding: "16px 20px 20px",
  "&:last-child": {
    paddingBottom: 20,
  },
}));
export const CardTitle = styled(Typography)<TypographyProps>(({ theme }) => ({
  fontWeight: 700,
  fontSize: 20,
  lineHeight: 1.25,
  marginTop: 8,
  marginBottom: 8,
  color: theme.palette.text.primary,

  [theme.breakpoints.down(910)]: {
    fontSize: 16,
  },
}));

export const RelatedMedia = styled(Box)(() => ({
  aspectRatio: "16 / 9",
  overflow: "hidden",

  img: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
}));

export const RelatedCardContent = styled(MuiCardContent)(() => ({
  padding: "12px 16px 16px",
  "&:last-child": {
    paddingBottom: 16,
  },
}));

export const RelatedCardTitle = styled(Typography)<TypographyProps>(({ theme }) => ({
  fontWeight: 700,
  fontSize: 14,
  lineHeight: 1.3,
  marginTop: 6,
  marginBottom: 6,
  color: theme.palette.text.primary,
}));

export const AuthorAvatar = styled(Avatar)(() => ({
  width: 24,
  height: 24,
  fontSize: 11,
  fontWeight: 600,
  backgroundColor: "#93B4F5",
  color: "#FFFFFF",
}));

export const Excerpt = styled(Typography)(() => ({
  fontSize: 13,
  lineHeight: 1.5,
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  marginTop: 4,
}));

export const CompactCard = styled(MuiCard)(() => ({
  position: "relative",
  borderRadius: 12,
  border: "1px solid #E5E7EB",
  boxShadow: "none",
  height: "100%",
  display: "flex",
  flexDirection: "column",
}));

export const CompactCardContent = styled(MuiCardContent)(() => ({
  padding: "20px 24px",
  display: "flex",
  flexDirection: "column",
  flex: 1,
  height: "100%",
  "&:last-child": {
    paddingBottom: 20,
  },
}));

export const CompactCardTitle = styled(Typography)<TypographyProps>(({ theme }) => ({
  fontWeight: 700,
  fontSize: 16,
  lineHeight: 1.35,
  marginTop: 8,
  marginBottom: 8,
  color: theme.palette.text.primary,
}));
